type OnBoardingConfig = {
  title: string;
  description: string;
  image: string;
};

type OnBoardingConfigs = OnBoardingConfig[];

/* V1 */
const onBoardingConfigsV1: OnBoardingConfigs = [
  {
    title: "JOIN ALPHA GROUPS",
    description:
      "Connect with top-tier alpha groups for exclusive token ideas. Your shortcut to the best trading insights starts here.",
    image: "/onboarding-1.png",
  },
  {
    title: "GET Token Calls",
    description:
      "Unlock real-time token calls and discover high-potential trades instantly. Simplify your token research and act fast.",
    image: "/onboarding-2.png",
  },
  {
    title: "Trade TOGETHER",
    description:
      "Turn alpha into action. Trade seamlessly across chains with Cabal Town's integrated swap feature.",
    image: "/onboarding-3.png",
  },
];

/* V2 */
const onBoardingConfigsV2: OnBoardingConfigs = [
  {
    title: "SHILL IS THE CURRENCY OF INFLUENCE",
    description: "You earn SHILL when you call tokens, share insights, or trade at Cabal Town.",
    image: "/onboarding-v2-1.png",
  },
  {
    title: "THE MORE YOU SHILL, THE MORE IT COUNTS",
    description:
      "Push your community up the leaderboard. Stand out with every call, take, or trade.",
    image: "/onboarding-v2-2.png",
  },
  {
    title: "TRADE THE BEST ALPHA",
    description:
      "Cabal Town analyzes activity across each group to identify the best alpha for you.",
    image: "/onboarding-v2-3.png",
  },
];

const onBoardingConfigsV3: OnBoardingConfigs = [
  {
    title: "Shill is the currency of influence",
    description: "You earn Shill when you call tokens, share insights, or trade at Cabal Town",
    image: "/onboarding-v3-1.png",
  },
  {
    title: "The more you Shill, the more it counts",
    description:
      "Push your community up the leaderboard. Stand out with every call, take, or trade",
    image: "/onboarding-v3-2.png",
  },
  {
    title: "Trade the best Alpha in real-time",
    description:
      "Cabal Town analyzes activity across each group to identify the best alpha for you",
    image: "/onboarding-v3-3.png",
  },
];

/* Versioning */
const onBoardingConfigs: Record<string, OnBoardingConfigs> = {
  v1: onBoardingConfigsV1,
  v2: onBoardingConfigsV2,
  v3: onBoardingConfigsV3,
};
// const configVersion = (process.env.REACT_APP_VERSION as keyof typeof onBoardingConfigs) || "v2";
// const onBoardingConfig = onBoardingConfigs[configVersion];

export { onBoardingConfigs, type OnBoardingConfig, type OnBoardingConfigs };
